module.exports = __webpack_public_path__ + "img/reboot-d.d417bd20.png";